module.exports = {
    BASE_API: 'https://www.rayotech.cn/slm/api/v1'
};



//////////////////
// WEBPACK FOOTER
// ./static/config/api.js
// module id = MpgJ
// module chunks = 58